import { render, staticRenderFns } from "./ProductCardSwiper.vue?vue&type=template&id=ad4cdfec&scoped=true&"
import script from "./ProductCardSwiper.vue?vue&type=script&lang=js&"
export * from "./ProductCardSwiper.vue?vue&type=script&lang=js&"
import style0 from "./ProductCardSwiper.vue?vue&type=style&index=0&id=ad4cdfec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad4cdfec",
  null
  
)

export default component.exports